subscribe('cart-update', (eventData) => {
    if (eventData.source == 'cart-items') {
        eventCartChange(eventData)
    } else if (eventData.source == 'product-form') {
        eventFormAdd(eventData)
    }
});

// Cache for performance
let cachedConfigs = null;
let cartElementCache = null;

function getCartElement() {
    if (!cartElementCache) {
        cartElementCache = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }
    return cartElementCache;
}

function getAutoAddConfigs() {
    if (cachedConfigs === null) {
        const el = document.querySelector('.auto-add-configs');
        if (!el) {
            cachedConfigs = [];
            return cachedConfigs;
        }
        
        try {
            cachedConfigs = JSON.parse(el.textContent.trim());
        } catch (e) {
            console.error('Invalid auto-add-configs JSON', e);
            cachedConfigs = [];
        }
    }
    return cachedConfigs;
}

// Utility functions for checkout button management
function disableCheckoutButtons() {
    document.querySelectorAll('.cart__checkout-button').forEach(button => {
        button.disabled = true;
    });
}

function enableCheckoutButtons() {
    document.querySelectorAll('.cart__checkout-button').forEach(button => {
        button.removeAttribute('hidden');
        button.disabled = false;
    });
}

function eventFormAdd(eventData) {
    const cartData = eventData.cartData;
    const cart = eventData.cart;

    if (!cartData || !cart) return;

    const autoAddConfigs = getAutoAddConfigs();
    if (!autoAddConfigs.length) return;

    // Early exit if no sections data
    if (!cartData.sections || !cartData.sections['cart-drawer']) return;

    const cartDrawerHTML = cartData.sections['cart-drawer'];
    
    // Use DOMParser for better performance
    const parser = new DOMParser();
    const doc = parser.parseFromString(cartDrawerHTML, 'text/html');
    const cartDataElement = doc.querySelector('.cart-data');
    
    if (!cartDataElement) return;

    try {
        const fullCartData = JSON.parse(cartDataElement.textContent);
        const itemsToAdd = [];

        autoAddConfigs.forEach(cfg => {
            const useCart = cfg.use_cart || false;
            const cartTotalThreshold = cfg.cart_total_threshold || 0;
            const getYVariantId = cfg.get_y_product?.variants?.[0]?.id;
            const giftQuantity = cfg.get_y_quantity || 1;
            const maxApplication = cfg.maximum_application || 1;

            if (!getYVariantId) return;

            // MODE 1: Cart total threshold mode
            if (useCart) {
                const cartTotal = fullCartData.total_price || 0;
                
                // Check if cart meets threshold
                if (cartTotal < cartTotalThreshold) return;
                
                // Count existing auto-added gifts for this promotion
                let existingGiftCount = 0;
                
                // Optimize loop
                for (let i = 0; i < fullCartData.items.length; i++) {
                    const item = fullCartData.items[i];
                    const properties = item.properties || {};
                    if (properties._auto_added_by_cart === String(cartTotalThreshold)) {
                        existingGiftCount += item.quantity;
                    }
                }

                // Calculate how many sets of gifts have been applied
                const setsApplied = Math.floor(existingGiftCount / giftQuantity);
                
                // Check if maximum applications has been reached
                if (setsApplied >= maxApplication) return;
                
                // Add one set of gifts
                itemsToAdd.push({
                    id: Number(getYVariantId),
                    quantity: giftQuantity,
                    properties: {
                        _auto_added_by_cart: String(cartTotalThreshold),
                        _auto_added_promotion: 'cart_threshold_' + cartTotalThreshold
                    }
                });
            } 
            // MODE 2: Product-based mode (original logic)
            else {
                const buyXProductId = cfg.buy_x_product?.id;
                const getXQuantity = cfg.get_x_product || 1;

                // Check if the added item matches the buy_x_product
                if (cartData.product_id !== buyXProductId) return;

                // Count total quantity of buy_x_product in cart
                let buyXTotalQuantity = 0;
                
                for (let i = 0; i < fullCartData.items.length; i++) {
                    const item = fullCartData.items[i];
                    if (item.product_id === buyXProductId) {
                        buyXTotalQuantity += item.quantity;
                    }
                }

                // Calculate how many sets of get_x_product we have
                const setsPurchased = Math.floor(buyXTotalQuantity / getXQuantity);
                
                // Count existing auto-added gifts for this promotion
                let existingGiftCount = 0;
                
                for (let i = 0; i < fullCartData.items.length; i++) {
                    const item = fullCartData.items[i];
                    const properties = item.properties || {};
                    if (properties._auto_added_by_product === String(buyXProductId)) {
                        existingGiftCount += item.quantity;
                    }
                }

                // Calculate how many sets of gifts have been applied
                const setsApplied = Math.floor(existingGiftCount / giftQuantity);
                
                // Calculate how many gift sets should be in cart based on purchased sets
                const giftSetsDesired = Math.min(setsPurchased, maxApplication);
                
                // Check if we need to add more gifts
                if (setsApplied >= giftSetsDesired) return;
                
                // Calculate how many more sets to add
                const setsToAdd = giftSetsDesired - setsApplied;
                const quantityToAdd = setsToAdd * giftQuantity;
                
                if (quantityToAdd > 0) {
                    itemsToAdd.push({
                        id: Number(getYVariantId),
                        quantity: quantityToAdd,
                        properties: {
                            _auto_added_by_product: String(buyXProductId),
                            _auto_added_promotion: 'buy_' + getXQuantity + '_get_' + giftQuantity
                        }
                    });
                }
            }
        });

        if (!itemsToAdd.length) return;

        // Disable checkout buttons before fetch
        disableCheckoutButtons();

        // Single optimized fetch call
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: itemsToAdd,
                sections: cart.getSectionsToRender().map(s => s.id),
                sections_url: window.location.pathname
            })
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        })
        .then(response => {
            if (cart.renderContents) {
                cart.renderContents(response);
            }
            // Re-enable checkout buttons after successful update
            enableCheckoutButtons();
        })
        .catch(error => {
            console.error('Error adding items:', error);
            // Re-enable checkout buttons even on error
            enableCheckoutButtons();
        });
    } catch (e) {
        console.error('Error parsing cart data:', e);
        // Re-enable checkout buttons on parsing error
        enableCheckoutButtons();
    }
}

function eventCartChange(eventData) {
    const cartItems = eventData.cartData.items;
    const cart = getCartElement();

    if (cartItems.length === 0) {
        cart?.classList.add('is-empty');
    } else {
        cart?.classList.remove('is-empty');
    }

    const autoAddConfigs = getAutoAddConfigs();
    if (!autoAddConfigs.length || !cartItems.length) return;

    const itemsToAdd = [];
    const updates = {};

    autoAddConfigs.forEach(cfg => {
        const useCart = cfg.use_cart || false;
        const cartTotalThreshold = cfg.cart_total_threshold || 0;
        const getYProductId = cfg.get_y_product?.id;
        const getYVariantId = cfg.get_y_product?.variants?.[0]?.id;
        const giftQuantity = cfg.get_y_quantity || 1;
        const maxApplication = cfg.maximum_application || 1;

        if (!getYVariantId) return;

        // Calculate cart total once
        let cartTotal = 0;
        if (useCart) {
            for (let i = 0; i < cartItems.length; i++) {
                const item = cartItems[i];
                cartTotal += (item.final_price || item.price) * item.quantity;
            }
        }

        // MODE 1: Cart total threshold mode
        if (useCart) {
            // Check if cart meets threshold
            const meetsThreshold = cartTotal >= cartTotalThreshold;
            
            // Find existing auto-added gift for this cart threshold
            let existingGiftItem = null;
            let existingGiftCount = 0;
            
            for (let i = 0; i < cartItems.length; i++) {
                const item = cartItems[i];
                const properties = item.properties || {};
                if (properties._auto_added_by_cart == String(cartTotalThreshold) && 
                    item.product_id == getYProductId) {
                    existingGiftItem = item;
                    existingGiftCount = item.quantity;
                    break; // Found it, no need to continue
                }
            }

            const quantityDesired = meetsThreshold ? Math.min(maxApplication, 1) * giftQuantity : 0;
            
            if (!existingGiftItem && quantityDesired > 0) {
                itemsToAdd.push({
                    id: Number(getYVariantId),
                    quantity: quantityDesired,
                    properties: {
                        _auto_added_by_cart: String(cartTotalThreshold),
                        _auto_added_promotion: 'cart_threshold_' + cartTotalThreshold
                    }
                });
            }
            else if (existingGiftItem && existingGiftCount !== quantityDesired) {
                updates[existingGiftItem.variant_id] = quantityDesired;
            }
        } 
        // MODE 2: Product-based mode (original logic)
        else {
            const buyXProductId = cfg.buy_x_product?.id;
            const getXQuantity = cfg.get_x_product || 1;

            if (!buyXProductId) return;

            let buyXTotalQuantity = 0;
            for (let i = 0; i < cartItems.length; i++) {
                const item = cartItems[i];
                if (item.product_id == buyXProductId) {
                    buyXTotalQuantity += item.quantity;
                }
            }

            const setsPurchased = Math.floor(buyXTotalQuantity / getXQuantity);
            
            let existingGiftItem = null;
            let existingGiftCount = 0;
            
            for (let i = 0; i < cartItems.length; i++) {
                const item = cartItems[i];
                const properties = item.properties || {};
                if (properties._auto_added_by_product == buyXProductId && 
                    item.product_id == getYProductId) {
                    existingGiftItem = item;
                    existingGiftCount = item.quantity;
                    break; // Found it, no need to continue
                }
            }

            const giftSetsDesired = Math.min(setsPurchased, maxApplication);
            const quantityDesired = giftSetsDesired * giftQuantity;
            
            if (!existingGiftItem && quantityDesired > 0) {
                itemsToAdd.push({
                    id: Number(getYVariantId),
                    quantity: quantityDesired,
                    properties: {
                        _auto_added_by_product: String(buyXProductId),
                        _auto_added_promotion: 'buy_' + getXQuantity + '_get_' + giftQuantity
                    }
                });
            }
            else if (existingGiftItem && existingGiftCount !== quantityDesired) {
                updates[existingGiftItem.variant_id] = quantityDesired;
            }
        }
    });

    // Process updates first (removals/changes), then additions
    const processUpdates = async () => {
        // Only proceed if there are updates or items to add
        if (Object.keys(updates).length === 0 && itemsToAdd.length === 0) return;

        // Disable checkout buttons before any fetch
        disableCheckoutButtons();
        
        try {
            if (Object.keys(updates).length > 0) {
                const formData = new FormData();
                
                for (const [id, quantity] of Object.entries(updates)) {
                    formData.append(`updates[${id}]`, quantity);
                }

                if (cart) {
                    const sections = cart.getSectionsToRender ? cart.getSectionsToRender().map((section) => section.id) : [];
                    formData.append('sections', sections.join(','));
                    formData.append('sections_url', window.location.pathname);
                }

                const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    body: formData
                });
                
                const data = await response.json();
                
                if (cart && cart.renderContents) {
                    cart.renderContents(data);
                }

                if (data.items && data.items.length == 0) {
                    if (cart) cart.classList.add('is-empty');
                }
            }
            
            // After updates, check if we need to add items
            if (itemsToAdd.length > 0) {
                await processAdditions();
            }
            
        } catch (error) {
            console.error('Error updating cart:', error);
        } finally {
            // Always re-enable checkout buttons after all operations
            enableCheckoutButtons();
        }
    };

    const processAdditions = async () => {
        if (itemsToAdd.length === 0) return;
        
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: itemsToAdd,
                    sections: cart?.getSectionsToRender ? cart.getSectionsToRender().map(s => s.id) : [],
                    sections_url: window.location.pathname
                })
            });
            
            const data = await response.json();
            if (cart && cart.renderContents) {
                cart.renderContents(data);
            }
        } catch (error) {
            console.error('Error adding items to cart:', error);
        }
    };

    // Start processing
    processUpdates();
}

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});
